/**
 * userPin.js
 *
 * @description A file that deals with managing user PINs.
 */

import { SVC_B } from './base'
import * as CryptoJS from 'crypto-js'

/**
 * A call to reset the user's PIN.
 *
 * @export
 * @param {String} userId A UUID for the user.
 * @returns The new pin to display to the user.
 */
export function updatePin (userId, pin) {
  return new Promise((resolve, reject) => {
    SVC_B.post(`/api/v1/users/${userId}/reset_pin`, { newPIN: hashPINForTransmission(pin) })
      .then(response => {
        if (response.data.ok) {
          resolve()
          return response.data
        }
        throw new Error(response.data.error)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  })
}

/**
 * @function hashPINForTransmission
 * @description hash a stored user PIN for transmission to front end.
 * @param storedPIN: hashed PIN as stored in database
 */
export function hashPINForTransmission (storedPIN) {
  const bytes = CryptoJS.HmacSHA256(storedPIN, 'lsZijCKxpXmMGoiDXF4dkTrjbuoFpjP3')
  const b64 = bytes.toString(CryptoJS.enc.Base64)
  return b64
}

export function getPINUsersForDomain (domainUUID) {
  return new Promise((resolve, reject) => {
    SVC_B.get(`/api/v1/users/${domainUUID}/pin_enabled`).then(data => {
      resolve(data)
    })
      .catch(error => {
        reject(error.message)
      })
  })
}
